export * from "./room-image.component";
